import { render, staticRenderFns } from "./pager.component.vue?vue&type=template&id=f1766c04&"
import script from "./pager.component.vue?vue&type=script&lang=ts&"
export * from "./pager.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pager.component.vue"
export default component.exports